import React from 'react'
import Select from 'react-select'
import Creatable from 'react-select/creatable'
import makeAnimated from 'react-select/animated'
import './styles/style.css'

export const CreatableSelect = (props) => {
  const optionsSelect =
    props.options &&
    props.options.map((option, index) => {
      return {
        value: option.name,
        label: option.name,
        option,
      }
    })

  let selectedOptions = null

  props.selectedOptions && Array.isArray(props.selectedOptions)
    ? (selectedOptions =
        props.selectedOptions &&
        props.selectedOptions.map((option) => {
          return {
            value: option.name,
            label: option.name,
            name: option.name,
            option,
          }
        }))
    : (selectedOptions = {
        ...props.selectedOptions,
        value: props.selectedOptions.name,
        label: props.selectedOptions.name,
      })

  return (
    <Creatable
      isMulti={true}
      name='form-field-name'
      value={selectedOptions}
      onChange={props.onChange}
      valueKey={props.valueKey || 'name'}
      labelKey={props.labelKey || 'name'}
      options={optionsSelect}
      // selectedOptions={selectedOptions}
      placeholder={props.placeholder || 'Not selected'}
      styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}

      // language={props.language}
    />
  )
}

/*eslint-disable*/
export default (props) => {
  const customStyles = props.customStyle
    ? {
        control: (provided, state) => ({
          ...provided,
          cursor: 'pointer',
          borderColor: 'rgb(1, 160, 242)', // Bootstrap text-primary color
          color: 'rgb(1, 160, 242)', // Bootstrap text-primary color
          fontWeight: '600',
          minHeight: '42px', // Ensure a minimum height
          '&:hover': {
            borderColor: 'rgb(1, 160, 242)', // Bootstrap text-primary color on hover
          },
          boxShadow: state.isFocused
            ? '0 0 0 1px rgb(1, 160, 242)'
            : provided.boxShadow,
        }),
        singleValue: (provided) => ({
          ...provided,
          color: 'rgb(1, 160, 242)', // Bootstrap text-primary color
          fontWeight: '600',
        }),
        placeholder: (provided) => ({
          ...provided,
          color: 'rgb(1, 160, 242)', // Bootstrap text-primary color
          fontWeight: '600',
          fontSize: '14px',
        }),
        dropdownIndicator: (provided) => ({
          ...provided,
          color: 'rgb(1, 160, 242)', // Bootstrap text-primary color for chevron icon
          '&:hover': {
            color: 'rgb(1, 160, 242)', // Bootstrap text-primary color on hover
          },
        }),
        indicatorSeparator: (provided) => ({
          ...provided,
          backgroundColor: 'rgb(1, 160, 242)', // Optional: color of the separator
        }),

        multiValue: (provided) => ({
          ...provided,
          backgroundColor: '#e9ecef', // Optional: light background for selected values
        }),
        multiValueLabel: (provided) => ({
          ...provided,
          color: 'rgb(1, 160, 242)', // Bootstrap text-primary color
          fontWeight: '600',
        }),
        multiValueRemove: (provided) => ({
          ...provided,
          color: 'rgb(1, 160, 242)', // Bootstrap text-primary color for remove icon
          ':hover': {
            backgroundColor: 'rgb(1, 160, 242)',
            color: 'white',
          },
        }),
        menuPortal: (base) => ({
          ...base,
          zIndex: 9999, // Ensure the menu has a high z-index
        }),
        menu: (provided) => ({
          ...provided,
          maxHeight: props.height !== null ? props.height : '200px', // Set maxHeight based on props.height
        }),
      }
    : {
        menuPortal: (base) => ({
          ...base,
          zIndex: 9999, // Ensure the menu has a high z-index
        }),
      }

  const selectedOptionStyle = props.selectedOption && {
    option: (provided, state) => {
      return {
        ...provided,
        backgroundColor:
          state.data.option.value === props.selectedOption?.value
            ? '#2684ff'
            : provided.backgroundColor,
        color:
          state.data.option.value === props.selectedOption?.value
            ? '#fff'
            : provided.color,
      }
    },
  }

  const mergedStyles = { ...customStyles, ...selectedOptionStyle }

  const optionsSelect = Array.isArray(props.options)
    ? props.options &&
      props.options.map((option, index) => {
        return {
          value: option.name,
          label: option.name,
          name: option.name,
          option,
        }
      })
    : []
  let selectedOptions = null
  props.selectedOptions && Array.isArray(props.selectedOptions)
    ? (selectedOptions =
        props.selectedOptions &&
        props.selectedOptions.map((option) => {
          return {
            value: option.name,
            label: option.name,
            name: option.name,
            option,
          }
        }))
    : props.selectedOptions &&
      (selectedOptions = {
        ...props.selectedOptions,
        value: props.selectedOptions.name,
        label: props.selectedOptions.name,
      })

  return (
    <Select
      isMulti={props.multi}
      name='form-field-name'
      // value={props.selectedOptions && props.selectedOptions.value}
      value={selectedOptions}
      onChange={props.onChange}
      valueKey={props.valueKey || 'name'}
      labelKey={props.labelKey || 'name'}
      options={optionsSelect}
      placeholder={props.placeholder || 'Not selected'}
      //   language={props.language}
      isClearable={true}
      ref={props.ref}
      // styles={props.styles}
      menuPortalTarget={document.body}
      menuPosition='fixed'
      styles={mergedStyles}
    />
  )
}
